// extracted by mini-css-extract-plugin
export default {"page":"GamePage_page__47y3-"};